<bs-digital-taxation-info [vm]="getTaxationVm()" [(isVisible)]="isTaxationInfoVisible" />

<bs-reward-used [badge]="badge" />
<div class="stake-info betslip-result-succeeded-pick__row">
    <span class="betslip-result-succeeded-pick__text">{{ stakeText }}</span>
    @if (stakeMultiplier) {
        <span class="betslip-result-succeeded-pick__each-way-multiplier">{{ stakeMultiplier }}</span>
    }
    <span class="betslip-result-succeeded-pick__stake__value" [class.betslip-result-succeeded-pick__stake__value--freebet]="isFreeBetSelected">{{
        stake | bsCurrency: true
    }}</span>
</div>
<span class="betslip-result-succeeded-pick__possible-winnings">
    @if (hideTaxation()) {
        <span class="betslip-result-succeeded-pick__text">{{ totalReturnsText }}</span>
    } @else {
        <div class="result-summary__net-returns">
            <span>{{ totalReturnsNetText }}</span>
            <span class="theme-info result-summary__taxation-info" (click)="displayTaxationInfo()"></span>
        </div>
    }

    <div class="betslip-results-bet-returns__possible-winnings">
        <span class="betslip-result-succeeded-pick__possible-winnings__value" [class.betslip-result-original-winnings]="boostedValue?.toNumber()">
            @if (possibleWinningsNet.greaterThan(0)) {
                {{ possibleWinningsNet | bsCurrency: true }}
            } @else if (possibleWinningsNet.equals(0)) {
                {{ null | bsCurrency: true }}
            }
        </span>
        @if (boostedValue?.toNumber()) {
            <span [msAutomation]="'betslip-result-summary__boosted-wins'">{{ boostedValue | bsCurrency: true }}</span>
        }
    </div>
</span>
@if (tokenPayout) {
    <bs-token-payout-summary [tokenPayoutSummary]="tokenPayout" />
}
